import {CatalogItem as GraphqlCatalogItem} from 'epic-graphql-types';
import {CountryInfo} from '../api/CatalogApi';
import {CatalogId, Namespace} from '../../types';

export enum CatalogTypes {
    CATALOG_FETCH_ITEM = 'CATALOG_FETCH_ITEM',
    CATALOG_FETCH_ITEM_SUCCESS = 'CATALOG_FETCH_ITEM_SUCCESS',
    CATALOG_FETCH_ITEM_FAILURE = 'CATALOG_FETCH_ITEM_FAILURE',

    CATALOG_BULK_FETCH_ITEMS = 'CATALOG_BULK_FETCH_ITEMS',
    CATALOG_BULK_FETCH_ITEMS_SUCCESS = 'CATALOG_BULK_FETCH_ITEMS_SUCCESS',

    GET_LATEST_CATALOG_UPDATE = 'GET_LATEST_CATALOG_UPDATE',
    GET_LATEST_CATALOG_UPDATE_SUCCESS = 'GET_LATEST_CATALOG_UPDATE_SUCCESS',
    GET_LATEST_CATALOG_UPDATE_FAILED = 'GET_LATEST_CATALOG_UPDATE_FAILED',

    ACK_CATALOG_UPDATE = 'ACK_CATALOG_UPDATE',
    SET_COUNTRY_FILTERING = 'SET_COUNTRY_FILTERING',

    GET_COUNTRY_INFO = 'GET_COUNTRY_INFO',
    GET_COUNTRY_INFO_COMPLETE = 'GET_COUNTRY_INFO_COMPLETE',
    GET_COUNTRY_INFO_FAILED = 'GET_COUNTRY_INFO_FAILED'
}

// @depreciated
export const TYPES = CatalogTypes;

export interface CatalogParams {
    namespace: string;
    id: string;
}

export interface BulkCatalogParamsPayload {
    params: CatalogParams[];
}

export interface CatalogItemPayload {
    catalogItem: GraphqlCatalogItem;
}

export interface BulkCatalogItemsPayload {
    catalogItems: GraphqlCatalogItem[];
}

export interface CatalogErrorPayload {
    error: any;
}

export interface TimestampPayload {
    timestamp: string;
}

export interface CountryInfoPayload {
    countryInfo: CountryInfo;
}

export interface CountryFilteringPayload {
    hasCountryFilter: boolean;
    filterCountry: string;
    filterAgeGroup: string;
}

export interface CatalogAction {
    type: CatalogTypes;
    payload?:
        | CatalogParams
        | BulkCatalogParamsPayload
        | CatalogItemPayload
        | CatalogErrorPayload
        | BulkCatalogItemsPayload
        | TimestampPayload
        | CountryInfoPayload
        | CountryFilteringPayload;
}

export default {
    // @depreciated
    TYPES,

    fetchCatalogItem: (namespace: Namespace, id: CatalogId): CatalogAction => ({
        type: CatalogTypes.CATALOG_FETCH_ITEM,
        payload: {namespace, id}
    }),

    fetchCatalogItemSuccess: (catalogItem: GraphqlCatalogItem): CatalogAction => ({
        type: CatalogTypes.CATALOG_FETCH_ITEM_SUCCESS,
        payload: {catalogItem}
    }),

    fetchCatalogItemFailure: (error: any): CatalogAction => ({
        type: CatalogTypes.CATALOG_FETCH_ITEM_FAILURE,
        payload: {error}
    }),

    bulkFetchCatalogItems: (params: CatalogParams[]): CatalogAction => ({
        type: CatalogTypes.CATALOG_BULK_FETCH_ITEMS,
        payload: {params}
    }),

    bulkFetchCatalogItemSuccess: (catalogItems: GraphqlCatalogItem[]): CatalogAction => ({
        type: CatalogTypes.CATALOG_BULK_FETCH_ITEMS_SUCCESS,
        payload: {catalogItems}
    }),

    getLatestCatalogUpdate: (): CatalogAction => ({
        type: CatalogTypes.GET_LATEST_CATALOG_UPDATE
    }),

    getLatestCatalogUpdateSuccess: (timestamp: string): CatalogAction => ({
        type: CatalogTypes.GET_LATEST_CATALOG_UPDATE_SUCCESS,
        payload: {timestamp}
    }),

    getLatestCatalogUpdateFailed: (): CatalogAction => ({
        type: CatalogTypes.GET_LATEST_CATALOG_UPDATE_FAILED
    }),

    ackCatalogUpdate: (timestamp: string): CatalogAction => ({
        type: CatalogTypes.ACK_CATALOG_UPDATE,
        payload: {timestamp}
    }),

    getCountryInfo: (): CatalogAction => ({
        type: CatalogTypes.GET_COUNTRY_INFO
    }),

    getCountryInfoSuccess: (countryInfo: CountryInfo): CatalogAction => ({
        type: CatalogTypes.GET_COUNTRY_INFO_COMPLETE,
        payload: {countryInfo}
    }),

    getCountryInfoFailed: (error: any): CatalogAction => ({
        type: CatalogTypes.GET_COUNTRY_INFO_FAILED,
        payload: {error}
    }),

    setCountryFiltering: (
        hasCountryFilter: boolean,
        filterCountry: string,
        filterAgeGroup: string
    ): CatalogAction => ({
        type: CatalogTypes.SET_COUNTRY_FILTERING,
        payload: {hasCountryFilter, filterCountry, filterAgeGroup}
    })
};
